import Paginate from "../../layout/Paginate";
import Button from "../../Shared/Button/Button";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import FilterRow from "./FilterRow";

const ListingFilters = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"Listing Filters"} dropdown={false} />
      <p className="mt-6 mb-[30px] font-pop text-base text-black text-opacity-50">
        Below are the current ad filters you have active.When a user lists a new
        ad it will be checked against your filters below.If a match is found you
        will be automatically notified by the system.{" "}
      </p>

      <div className=" gap-y-5 border border-lightGray px-6 py-5">
        <div className="grid grid-cols-[290px_200px_auto_120px_200px] ">
          <p className="border-b border-lightGray pb-4 font-pop text-base font-bold text-darkGreen">
            Categories to Search
          </p>
          <p className="border-b border-lightGray pb-4 font-pop text-base font-bold text-darkGreen">
            Search term to use
          </p>
          <p className="border-b border-lightGray pb-4 font-pop text-base font-bold text-darkGreen">
            City
          </p>
          <p className="border-b border-lightGray pb-4 font-pop text-base font-bold text-darkGreen">
            Date Created
          </p>
          <p className="border-b border-lightGray pb-4 font-pop text-base font-bold text-darkGreen"></p>
        </div>

        <Paginate
          element={(props) => <FilterRow {...props} />}
          data={new Array(20).fill(0)}
          itemsPerPage={8}
          containerClassName="_"
        />
      </div>
      <div className="my-12 grid grid-cols-4 gap-x-2.5">
        <div></div>
        <div></div>
        <Button text="Delete Filter" variant="red" className=" !w-full" />
        <Button text="New Filter" variant="secondary" className=" !w-full" />
      </div>
    </div>
  );
};

export default ListingFilters;
